import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { logSentry } from '../utils/sentry';

declare const window: any;

export const customQtyApi = createApi({
    reducerPath: 'customQty',
    baseQuery: fetchBaseQuery({
        baseUrl: window.Config?.LAMBDA_CUSTOM_QTY_SLIDER_API,
        prepareHeaders: (headers) => {
            headers.set('Content-Type', 'application/json')
            headers.set(window.Config?.NP_API_KEY_HEADER_NAME ?? "x-api-key", window.Config?.NP_API_KEY_CLIENT_JS)
            return headers
        },
    }),
    tagTypes: ['CustomQty'],
    endpoints: (builder) => ({
        getCustomQty: builder.mutation({
            query: ({productKey, locale}) => ({
                url : `/qtySlider/${productKey}/${locale}`,
                method: 'GET'
            }),
            async onQueryStarted(args, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled;
                    if(data?.data) return data?.data?.supportCustomQty;
                    else throw "Error while fetching custom qty info";
                }
                catch (error) {
                    console.log("Error in custom qty sider api",error);
                    logSentry({
                        'page': 'shoppingBag',
                        'feature': 'getCustomQty',
                        'operation': 'getCustomQty',
                        'errorType': 'ajaxError',
                        'err': JSON.stringify(error),
                        'func': 'customQtyApi',
                        'api': null,
                        'errMsg': 'Error: while fetching custom qty slider info'
                    })
                    return false;
                }
            }
        })
    })
})

export const { useGetCustomQtyMutation } = customQtyApi;